module.exports = __webpack_public_path__ + "img/w3_chevron_up_light.f7a1d3a6.f7a1d3a6.png";